import React from 'react';
import PropTypes from 'prop-types';
// import withOnCriticalError from 'view/ErrorBoundary/withOnCriticalError';
import Loader from '../../../Layout/Loader';
import parseMobileApplication from '../../../Helpers/parseMobileApplication';
import callNativeAppInfo from '../../../Helpers/callNativeAppInfo';
import setAuthCredentials from '../../setAuthCredentials';

class AuthLoginByTokenComponent extends React.Component {
  static propTypes = {
    token: PropTypes.string,
    children: PropTypes.node.isRequired,
    userDataOnDemand: PropTypes.func.isRequired,
  };

  static defaultProps = {
    token: undefined,
  };

  state = {
    initialized: false,
    appInfo: undefined,
  };

  async componentDidMount() {
    const mobileApp = parseMobileApplication();

    const developerOptionsMobileAppMode = window.localStorage.getItem(
      'developerOptionsMobileAppMode'
    );
    if (developerOptionsMobileAppMode === 'on') {
      window.localStorage.setItem('mobileApp', '{"active":true,"os":null,"version":null}');
    } else {
      window.localStorage.setItem('mobileApp', JSON.stringify(mobileApp));
    }

    if (mobileApp.active) {
      if (this.props.token) {
        // is mobile and new version native application and token is set
        await this.props.userDataOnDemand();
        this.setState({ initialized: true });
      } else {
        // is mobile and new version native application and token is not set
        // setTimeout(async () => {
        //   if (!this.state.appInfo) {
        //     this.setState({ initialized: true });
        //   }
        // }, 5000);

        window.addEventListener('message', this.receiveMessage, false);
        callNativeAppInfo();
      }
    } else {
      if (this.props.token) {
        try {
          await this.props.userDataOnDemand();
          this.setState({ initialized: true });
        } catch (error) {
          if (error.name !== 'AbortError') {
            // handle the non-abort error in some way
            console.warn(error);
          }
        }
      } else {
        this.setState({ initialized: true });
      }
    }
  }

  async componentDidUpdate() {
    if (!this.state.initialized && this.state.appInfo) {
      if (this.state.appInfo.payload && this.state.appInfo.payload.authenticationToken) {
        setAuthCredentials(this.state.appInfo.payload.authenticationToken);
      }
      const mobileApp = {
        active: true,
        os: this.state.appInfo.payload.os,
        version: this.state.appInfo.payload.appVersion,
      };

      const developerOptionsMobileAppMode = window.localStorage.getItem(
        'developerOptionsMobileAppMode'
      );
      if (developerOptionsMobileAppMode === 'on') {
        window.localStorage.setItem('mobileApp', '{"active":true,"os":null,"version":null}');
      } else {
        window.localStorage.setItem('mobileApp', JSON.stringify(mobileApp));
      }

      // set language
      if (this.state.appInfo.payload.language) {
        console.log('set language', this.state.appInfo.payload.language);
        window.localStorage.setItem(
          'i18nextLng',
          this.state.appInfo.payload.language.replace('_', '-')
        );
      }

      this.setState({ initialized: true });
      await this.props.userDataOnDemand();

      // fix for iOS to refresh webview after language change
      if (this.state.appInfo.payload && this.state.appInfo.payload.authenticationToken) {
        window.location.reload();
      }
    }
  }

  receiveMessage = (event) => {
    if (!this.state.initialized && event.data.action === 'response_app_info') {
      this.setState({ appInfo: event.data });
    }
  };

  render() {
    if (this.state.initialized) {
      return this.props.children;
    }

    return (
      <div className="full-height">
        <Loader />
      </div>
    );
  }
}

export { AuthLoginByTokenComponent };
export default AuthLoginByTokenComponent;
